import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  API,
  LoadingContent,
} from 'vibeguide';
import IdentityProviderDetails from './IdentityProviderDetails';

function IdentityProviderSidebar({
  className = '',
  identityProviderId = '',
  isNew = false,
}) {
  const [identityProvider, setIdentityProvider] = useState({
    name: '',
    domains: [],
    cognitoAppClientId: '',
    cognitoProviderName: '',
  });

  /**
   * Get Identity Provider Details
   */
  const getIdentityProvider = async () => {
    const response = await API.IdentityProvider.getById(identityProviderId);
    setIdentityProvider(response);
  };

  /**
   * Update the identity provider
   */
  const onUpdate = (data) => {
    setIdentityProvider({
      ...identityProvider,
      ...data,
    });
  };

  /**
   * Get the identity provider if the ID changes
   */
  useEffect(() => {
    if (identityProviderId && !isNew) {
      getIdentityProvider();
    }
  }, [identityProviderId]);

  if (identityProviderId && !isNew && !identityProvider._id) {
    // identity provider hasn't been fetched from the API yet
    return (
      <LoadingContent />
    );
  }

  return (
    <div
      className={classNames('IdentityProviderSidebar', className)}
      style={{
        height: '100%',
      }}
    >
      <IdentityProviderDetails
        identityProvider={identityProvider}
        isNew={isNew}
        onUpdate={onUpdate}
      />
    </div>
  );
}

IdentityProviderSidebar.propTypes = {
  className: PropTypes.string,
  identityProviderId: PropTypes.string,
  isNew: PropTypes.bool,
};

export default IdentityProviderSidebar;
